import React from 'react';
import { Modal } from 'react-responsive-modal';

const AddMemberLeave = ({ open, onClose, id }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      showCloseIcon={false}
      classNames={{ modal: 'custom-modal1' }}
    >
      <div className="d-flex justify-content-between align-items-center p-2">
        <h6>Add Leave</h6>
        <i
          onClick={onClose}
          className="fa fa-times font-20"
          style={{ cursor: 'pointer' }}
        ></i>
      </div>
      <div className="">
        <div className="form-group ">
          <label for="username10" className="font-14 text-muted ">
            Member
          </label>
          <input
            type="text"
            className="form-control"
            placeholder="Name"
            id="username10"
          />
        </div>
        <div className="form-group ">
          <label for="username1" className="font-14 text-muted ">
            Leave Policy
          </label>
          <div className="">
            <select className="form-control">
              <option value="true">vacation</option>
              <option value="false">holiday</option>
            </select>
          </div>
        </div>
        <div className="d-flex " style={{ gap: '5px' }}>
          <div className="form-group ">
            <label for="username4" className="font-14 text-muted ">
              Start
            </label>
            <input
              type="date"
              className="form-control"
              id="username4"
              style={{ width: '177px' }}
            />
          </div>
          <div className="form-group  ">
            <label for="username5" className="font-14 text-muted ">
              End
            </label>
            <input
              type="date"
              className="form-control"
              id="username5"
              style={{ width: '177px' }}
            />
          </div>
        </div>

        <div className="form-group ">
          <label for="username7" className="font-14 text-muted ">
            Leave Duration
          </label>
          <div className="">
            <select className="form-control">
              <option value="true">Full Day</option>
              <option value="false">1st Half</option>
              <option value="no">2nd Half</option>
            </select>
          </div>
        </div>

        <textarea
          type="text"
          className="form-control mt-2"
          rows={3}
          placeholder="Reason"
        />
      </div>

      <div className="modal-footer mt-2">
        <button type="button" className="btn btn-light" onClick={onClose}>
          Cancel
        </button>
        <button type="button" className="btn btn-dark">
          Add Leave
        </button>
      </div>
    </Modal>
  );
};

export default AddMemberLeave;
